import React, { useEffect, useState } from "react";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import { SvgImages } from "../../Utils/LocalImages";
import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import DataProvider from "../../Utils/DataProvider";
import StateService from "../../Services/StateService";
import CouponServices from "../../Services/CouponServices";
import ClassService from "../../Services/ClassService";
import DistrictService from "../../Services/DistrictService";
import TalukaService from "../../Services/TalukaService";
import PincodeService from "../../Services/PincodeService";
import AuthService from "../../Services/AuthService";
import RoutesPath from "../../Utils/RoutesPath";
const AddStudents = () => {
    const [studentList, setStudentList] = useState({ ...useLocation().state });
    const [applicablePackages, setApplicablePackages] = useState([]);
    const [resetMedium, setResetMedium] = useState(false);
    const [selectedApplicablePackages, setSelectedApplicablePackages] = useState([]);
    const [states, setStates] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [talukas, setTalukas] = useState([]);
    const [filterDistricts, setFilterDistricts] = useState([]);
    const [filterTalukas, setFilterTalukas] = useState([]);
    const [resetDistrict, setResetDistrict] = useState(false);
    const [resetApplicablePackages, setResetApplicablePackages] = useState(false);

    const [resetTaluka, setResetTaluka] = useState(false);
    const [resetFilterDistrict, setResetFilterDistrict] = useState(false);
    const [resetFilterTaluka, setResetFilterTaluka] = useState(false);
    const [selectedStateFilter, setSelectedStateFilter] = useState("");
    const [selectedDistrictFilter, setSelectedDistrictFilter] = useState("");
    const [selectedTalukaFilter, setSelectedTalukaFilter] = useState("");

    // const [details, setDetails] = useState(null);
    const [classes, setClasses] = useState([]);

    const navigate = useNavigate();
    const Validations = Yup.object().shape({
        firstname: validationRegex.required,
        middlename: validationRegex.required,
        lastname: validationRegex.required,
        gender: validationRegex.required,
        schoolname: validationRegex.required,
        dateOfBirth: validationRegex.dob,
        medium: validationRegex.required,
        class_id: validationRegex.required,
        email: validationRegex.email,
        mobilenumber: validationRegex.mobile,
        address: validationRegex.required,
        state: validationRegex.required,
        district: validationRegex.required,
        taluka: validationRegex.required,
        pincode: validationRegex.required,
    });
    const {
        register: register,
        handleSubmit: handleSubmit,
        setValue: setValue,
        watch: watchdetails,
        formState: { errors: errors },
        getValues: getValues
    } = useForm({
        resolver: yupResolver(Validations),
        defaultValues: {
            firstname: studentList?.firstName || "",
            middlename: studentList?.middleName || "",
            lastname: studentList?.lastName || "",
            gender: studentList?.gender || "",
            schoolname: studentList?.schoolName || "",
            dateOfBirth: studentList?.dateOfBirth || "",
            medium: studentList?.medium || "",
            class_id: studentList?.classId || "",
            email: studentList?.email || "",
            mobilenumber: studentList?.mobile || "",
            address: studentList?.addressLineOne || "",
            state: studentList?.state || "",
            district: studentList?.district || "",
            taluka: studentList?.taluka || "",
            pincode: studentList?.pinCode || "",
            applicablepackages: studentList?.packages || "",
        },
    });
    const onSubmit = async (studentData) => {
        const applicablePackagesIds =
            selectedApplicablePackages.length > 0
                ? selectedApplicablePackages.map((pkg) => pkg.value) // If user selects packages, use them
                : studentData.applicablepackages === undefined ||
                    studentData.applicablepackages.length === 0
                    ? [] // If the user sends an empty array, keep it empty
                    : studentList.packages
                        ? studentList.packages.map((pkg) => pkg.package_id) // Otherwise, use default couponList packages
                        : [];

        try {
            const response = await AuthService.registerUser(
                studentList?.user_id || "",
                studentData.firstname,
                studentData.middlename,
                studentData.lastname,
                studentData.gender,
                studentData.schoolname,
                studentData.dateOfBirth,
                studentData.medium,
                studentData.class_id,
                studentData.email,
                studentData.mobilenumber,
                studentData.address,
                studentData.state,
                studentData.district,
                studentData.taluka,
                studentData.pincode,
                // couponData.applicablepackages,
                applicablePackagesIds,
            );
            toast.success(response.message);

            setStudentList({});
            navigate(RoutesPath.viewStudents)
        } catch (error) {
            // Handle API errors
            handleApiErrors(error);

        }
    };
    const getAllClasses = async () => {
        try {
            const response = await ClassService.getAllClassesWithoutPagination();
            setClasses(response.data);

        } catch (error) {
            handleApiErrors(error);
        }
    };

    const getAllStates = async () => {
        try {
            const response = await StateService.getAll();
            setStates(response.data);
        } catch (error) {
            handleApiErrors(error);
        }
    };

    const getAllDistricts = async (state_id) => {
        try {
            const response = await DistrictService.getAll(state_id);
            setDistricts(state_id ? response.data : []);
        } catch (error) {
            handleApiErrors(error);
        }
    };

    const getAllFilterDistricts = async (state_id) => {
        try {
            const response = await DistrictService.getAll(state_id);
            setFilterDistricts(state_id ? response.data : []);
        } catch (error) {
            handleApiErrors(error);
        }
    };

    const getAllTalukas = async (district_id) => {
        try {
            const response = await TalukaService.getAll(district_id);
            setTalukas(district_id ? response.data : []);
        } catch (error) {
            handleApiErrors(error);
        }
    };

    const getAllFilterTalukas = async (district_id) => {
        try {
            const response = await TalukaService.getAll(district_id);
            setFilterTalukas(district_id ? response.data : []);
        } catch (error) {
            handleApiErrors(error);
        }
    };
    useEffect(() => {
        // Reset taluka when district changes
        if (resetFilterDistrict) {
            setSelectedTalukaFilter("");
            setResetFilterDistrict(false);
        }
    }, [resetFilterDistrict]);
    useEffect(() => {
        if (studentList) {
            const formattedDate =
                studentList?.dateOfBirth instanceof Date
                    ? studentList.dateOfBirth.toLocaleDateString("en-CA").split('T')[0]
                    : (studentList?.dateOfBirth
                        ? new Date(studentList?.dateOfBirth.split("/").reverse().join("-")).toLocaleDateString("en-CA").split('T')[0]
                        : ""
                    );

            setValue("dateOfBirth", formattedDate);
        }
    }, [studentList, setValue]);
    useEffect(() => {
        getAllClasses();
        getAllStates();
        // getAppicablePackagesWithoutPagination();
    }, [])

    useEffect(() => {
        fetchData();
    }, [selectedStateFilter, selectedDistrictFilter, selectedTalukaFilter])

    const fetchData = async () => {
        try {
            const response = await PincodeService.get(
                offset,
                limit,
                searchQuery || "",
                selectedStateFilter,
                selectedDistrictFilter,
                selectedTalukaFilter
            );
            setData(response.data);

            setAvailableDataCount(response.availableDataCount);

            if (offset != 0 && offset * limit > availableDataCount - 1) {
                setOffset(offset - 1);
            }
        } catch (error) {
            handleApiErrors(error);
        }
    };
    const getAppicablePackagesWithoutPagination = async (class_id) => {
        try {
            const response =
                await CouponServices.getAppicablePackagesWithoutPagination(class_id);
            setApplicablePackages(response.data);
        } catch (error) {
            handleApiErrors(error);
        }
    };

    return (
        <div>
            <div className="mb-3 d-flex justify-content-between">
                <h1 className="black fs-18 fw-600 mb-0">STUDENTS</h1>
                <div className="d-flex">
                    <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
                    <h4 className="fs-12 fw-500 primary mb-0">studetns</h4>
                </div>
            </div>
            <div className="table_container" style={{ display: "block" }}>
                <div className="table_title ps-2">
                    <div className="table_headings">
                        <h1 className="black fs-18 fw-600 mb-0">
                            {studentList.user_id ? "Edit Personal Details" : "Personal Details"}
                        </h1>
                    </div>

                    <form className="" onSubmit={handleSubmit(onSubmit)}>
                        {/* personal details */}
                        <div className="row profile_inputs w-100 mt-4">
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="First Name"
                                    placeholder="First Name"
                                    name="firstname"
                                    id="firstname"
                                    additionalClasses="profile_edit"
                                    inputType={InputType.text}
                                    showMandatory={true}
                                    register={register}
                                    showError={errors.firstname}
                                    errorMessage={errors?.firstname?.message}
                                    setValue={setValue}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Middle Name"
                                    placeholder="Middle Name"
                                    name="middlename"
                                    id="middlename"
                                    additionalClasses="profile_edit"
                                    inputType={InputType.text}
                                    showMandatory={true}
                                    setValue={setValue}
                                    register={register}
                                    showError={errors?.middlename}
                                    errorMessage={errors?.middlename?.message}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Last Name"
                                    placeholder="Last Name"
                                    name="lastname"
                                    id="lastname"
                                    additionalClasses="profile_edit"
                                    inputType={InputType.text}
                                    showMandatory={true}
                                    setValue={setValue}
                                    register={register}
                                    showError={errors?.lastname}
                                    errorMessage={errors?.lastname?.message}
                                />
                            </div>
                            <div className="col-md-6">
                                {/* {classes && classes.length != 0 && ( */}
                                <CustomDropDown
                                    labelTitle="Gender"
                                    id="gender"
                                    name="gender"
                                    placeholder="Select Gender"
                                    showError={errors?.gender}
                                    errorMessage={errors?.gender?.message}
                                    register={register}
                                    setValue={setValue}
                                    additionalClasses="profile_edit"
                                    options={DataProvider.Genders}
                                    showMandatory={true}
                                    defaultOption={() => {
                                        return studentList.gender
                                            ? { value: studentList.gender, label: studentList.gender }
                                            : null;
                                    }}
                                />
                                {/* )} */}
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Date of Birth"
                                    id="dateOfBirth"
                                    name="dateOfBirth"
                                    showError={errors?.dateOfBirth}
                                    errorMessage={errors?.dateOfBirth?.message}
                                    register={register}
                                    additionalClasses="profile_edit"
                                    inputType="date"
                                    setValue={setValue}
                                    showMandatory={true}
                                />
                            </div>


                        </div>


                        {/* School details */}
                        <div className="school_details">
                            <div className="table_headings">
                                <h1 className="black fs-18 fw-600 mb-0">
                                    School Details
                                </h1>
                            </div>

                            <div className="row profile_inputs w-100 mt-4">
                                <div className="col-md-6">
                                    <CustomTextField
                                        labelTitle="School Name"
                                        placeholder="School Name"
                                        name="schoolname"
                                        id="schoolname"
                                        additionalClasses="profile_edit"
                                        inputType={InputType.text}
                                        showMandatory={true}
                                        register={register}
                                        showError={errors.schoolname}
                                        errorMessage={errors?.schoolname?.message}

                                    />
                                </div>
                                <div className="col-md-6">
                                    <CustomDropDown
                                        labelTitle="Select Medium"
                                        placeholder="Select Medium"
                                        name="medium"
                                        id="medium"
                                        additionalClasses="profile_edit"
                                        setResetValue={setResetMedium}
                                        resetValue={resetMedium}
                                        inputType={InputType.text}
                                        showError={errors?.medium}
                                        errorMessage={errors?.medium?.message}
                                        showMandatory={true}
                                        setValue={setValue}
                                        options={DataProvider.mediumList}
                                        defaultOption={() => {
                                            return studentList.medium
                                                ? {
                                                    value: studentList.medium,
                                                    label: studentList.medium,
                                                }
                                                : null;
                                        }}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <CustomDropDown
                                        labelTitle="Select Class"
                                        placeholder="Select"
                                        name="class_id"
                                        id="class_id"
                                        additionalClasses="profile_edit"
                                        inputType={InputType.text}
                                        showError={errors?.class_id}
                                        errorMessage={errors?.class_id?.message}
                                        showMandatory={true}
                                        setValue={setValue}
                                        onChange={(e) => {
                                            getAppicablePackagesWithoutPagination(e.value);
                                            setResetApplicablePackages(true);
                                            setSelectedApplicablePackages([]);
                                        }}
                                        options={
                                            classes?.map((e) => { return { value: e._id, label: e.class_name } })
                                        }
                                        defaultOption={() => {
                                            return (studentList.classId && studentList.class_name) ? { value: studentList.classId, label: studentList.class_name } : null
                                        }}
                                    />
                                </div>


                            </div>
                        </div>
                        {/* Contact details */}
                        <div className="contact_details">
                            <div className="table_headings">
                                <h1 className="black fs-18 fw-600 mb-0">
                                    Contact Details
                                </h1>
                            </div>
                            <div className="row profile_inputs w-100 mt-4">
                                <div className="col-md-6">
                                    <CustomTextField
                                        labelTitle="Email ID"
                                        placeholder="Email ID"
                                        name="email"
                                        id="email"
                                        additionalClasses="profile_edit"
                                        inputType={InputType.text}
                                        showMandatory={true}
                                        register={register}
                                        showError={errors.email}
                                        errorMessage={errors?.email?.message}

                                    />
                                </div>
                                <div className="col-md-6">
                                    <CustomTextField
                                        labelTitle="Mobile Number"
                                        placeholder="Mobile Number"
                                        name="mobilenumber"
                                        id="mobilenumber"
                                        additionalClasses="profile_edit"
                                        inputType={InputType.text}
                                        showMandatory={true}
                                        register={register}
                                        showError={errors?.mobilenumber}
                                        errorMessage={errors?.mobilenumber?.message}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <CustomTextField
                                        labelTitle="Address"
                                        placeholder="Address"
                                        name="address"
                                        id="address"
                                        additionalClasses="profile_edit"
                                        inputType={InputType.text}
                                        showMandatory={true}
                                        register={register}
                                        showError={errors?.address}
                                        errorMessage={errors?.address?.message}
                                    />
                                </div>



                            </div>
                        </div>

                        {/* Location details */}
                        <div className="location_details">
                            <div className="table_headings">
                                <h1 className="black fs-18 fw-600 mb-0">
                                    Location Details
                                </h1>
                            </div>
                            <div className="row profile_inputs w-100 mt-4">
                                <div className="col-md-6">
                                    <CustomDropDown
                                        labelTitle="State"
                                        placeholder="Select State"
                                        name="state"
                                        id="state"
                                        showError={errors?.state}
                                        errorMessage={errors?.state?.message}
                                        setValue={setValue}
                                        register={register}
                                        additionalClasses="profile_edit"
                                        inputType={InputType.text}
                                        showMandatory={true}
                                        onChange={(e) => {
                                            setResetDistrict(true);
                                            setResetTaluka(true);
                                            getAllDistricts(e.value);
                                        }}
                                        options={
                                            states.map((e) => { return { value: e._id, label: e.name } })
                                        }
                                        defaultOption={() => {
                                            return studentList.state ? { value: studentList.state, label: studentList.state } : null
                                        }}
                                    />


                                </div>
                                <div className="col-md-6">
                                    <CustomDropDown
                                        labelTitle="District"
                                        placeholder="Select District"
                                        name="district"
                                        id="district"
                                        showError={errors?.district}
                                        errorMessage={errors?.district?.message}
                                        setValue={setValue}
                                        register={register}
                                        additionalClasses="profile_edit"
                                        inputType={InputType.text}
                                        resetValue={resetDistrict}
                                        setResetValue={setResetDistrict}
                                        showMandatory={true}
                                        onChange={(e) => {
                                            setResetTaluka(true);
                                            getAllTalukas(e.value);
                                        }}
                                        options={
                                            districts.map((e) => { return { value: e._id, label: e.name } })
                                        }
                                        defaultOption={() => {
                                            return studentList.district ? { value: studentList.district, label: studentList.district } : null
                                        }}
                                    />


                                </div>
                                <div className="col-md-6">
                                    <CustomDropDown
                                        labelTitle="Taluka"
                                        placeholder="Select Taluka"
                                        name="taluka"
                                        id="taluka"
                                        showError={errors?.taluka}
                                        errorMessage={errors?.taluka?.message}
                                        setValue={setValue}
                                        register={register}
                                        additionalClasses="profile_edit"
                                        inputType={InputType.text}
                                        resetValue={resetTaluka}
                                        setResetValue={setResetTaluka}
                                        showMandatory={true}
                                        options={
                                            talukas.map((e) => { return { value: e._id, label: e.name } })
                                        }
                                        defaultOption={() => {
                                            return studentList.taluka ? { value: studentList.taluka, label: studentList.taluka } : null
                                        }}
                                    />


                                </div>
                                <div className="col-md-6">
                                    <CustomTextField
                                        labelTitle="Pincode"
                                        placeholder="Enter pincode"
                                        name="pincode"
                                        id="pincode"
                                        showError={errors?.pincode}
                                        errorMessage={errors?.pincode?.message}
                                        register={register}
                                        additionalClasses="profile_edit"
                                        showMandatory={true}
                                    />


                                </div>


                            </div>
                        </div>

                        {/* Package Assignment */}
                        <div className="location_details">
                            <div className="table_headings">
                                <h1 className="black fs-18 fw-600 mb-0">
                                    Package Assignment
                                </h1>
                            </div>
                            <div className="row profile_inputs w-100 mt-4">


                                <div className="col-md-7">
                                    <CustomDropDown
                                        labelTitle="Package ( Comma-separated list of Package IDs)"
                                        placeholder="packages"
                                        name="applicablepackages"
                                        id="applicablepackages"
                                        additionalClasses="profile_edit"
                                        inputType={InputType.select} // Changed to select for multiple options
                                        showError={errors?.applicablepackages}
                                        errorMessage={errors?.applicablepackages?.message}
                                        // showMandatory={true}
                                        setValue={setValue}
                                          resetValue={resetApplicablePackages}
                                        setResetValue={setResetApplicablePackages}
                                        onChange={(selectedOptions) => {
                                            setSelectedApplicablePackages(selectedOptions);
                                        }}
                                        options={applicablePackages?.map((e) => {
                                            return { value: e.package_id, label: e.packageName };
                                        })}
                                        isMulti={true}
                                        defaultOption={() => {
                                            return studentList.packages
                                                ? studentList.packages.map((pkg) => ({
                                                    value: pkg.package_id,
                                                    label: pkg.packageName,
                                                }))
                                                : null;
                                        }}
                                    />
                                </div>

                                <div className="d-flex justify-content-end mt-3">
                                    <ButtonWithIcon
                                        text={studentList?.user_id ? "Update" : "Submit"}
                                        icon={SvgImages.tick_mark}
                                        onClick={handleSubmit(onSubmit)}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddStudents;
